// console.log("pc-fitment script run (static shell)");

(async function () {
  const script =
    document.currentScript ||
    document.querySelector('script[src*="pc-fitment.js"]') ||
    document.querySelector('script[src*="pc-hero-dd.js"]');

  const root = document.getElementById("pc-fitment-root");
  if (!root || !script) return;

  /* ---------------- required static DOM refs ---------------- */

  const els = {
    outOfStock: document.querySelector("#fitment_target").dataset.outofstock,
    titleUrl: root.querySelector("#pcfit-title"),
    titlePage: root.querySelector("#pcfit-page-title"),
    bc: root.querySelector("#pcfit-bc"),
    panel: root.querySelector("#pcfit-panel"),
    head: root.querySelector("#pcfit-panel-head"),
    headTitle: root.querySelector("#pcfit-panel-title"),
    back: root.querySelector("#vs-back-global"),

    body: root.querySelector("#pcfit-panel-body"),
    dynamic: root.querySelector("#pcfit-dynamic"),

    atcWrap: root.querySelector("[data-atc-scope]"),
    atcBtn: root.querySelector("[data-atc-btn]"),
    anotherBtn: root.querySelector("[data-another-btn]"),
    atcError: root.querySelector("[data-atc-error]"),
  };

  console.log("els.ddWrapper", els.outOfStock);

  if (!els.body) {
    console.warn("[pcfit] #pcfit-panel-body not found. Ensure static shell HTML exists.");
    return;
  }

  if (!els.dynamic) {
    console.warn("[pcfit] #pcfit-dynamic not found. Please add <div id='pcfit-dynamic'>...</div> into panel body.");
    return;
  }

  if (!els.atcWrap || !els.atcBtn || !els.anotherBtn) {
    console.warn("[pcfit] Static ATC shell not found. Please add .parent-atc_another with #atc_btn and #generic_another_btn.");
  }

  // data attrs
  const pcMakeModelUrl = script.dataset.pcMakemodel || "/products/pc-makeModel.json";
  const prioritizedMakesUrl = script.dataset.prioritizedMakes || "/products/prioritizedMakes.json";
  const prioritizedModelsUrl = script.dataset.prioritizedModels || "/products/prioritizedModels.json";

  /* ---------------- helpers ---------------- */

  const STORAGE_NAMESPACE = "pcFitment";

  const norm = (s) => (s || "").toString().trim().toLowerCase();

  const esc = (s) =>
    (s || "").toString().replace(/[&<>"']/g, (c) => {
      const map = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
      return map[c] || c;
    });

  const getStorageKey = (key, url) => `${STORAGE_NAMESPACE}:${key}:${url}`;

  const clearOldVersions = (key, currentUrl) => {
    try {
      const prefix = `${STORAGE_NAMESPACE}:${key}:`;

      for (let i = localStorage.length - 1; i >= 0; i--) {
        const storageKey = localStorage.key(i);
        if (!storageKey) continue;
        if (!storageKey.startsWith(prefix)) continue;
        if (storageKey === getStorageKey(key, currentUrl)) continue;

        localStorage.removeItem(storageKey);
      }
    } catch {}
  };

  const getFromStorage = (key, url) => {
    try {
      const raw = localStorage.getItem(getStorageKey(key, url));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  const saveToStorage = (key, url, data) => {
    try {
      clearOldVersions(key, url);
      localStorage.setItem(getStorageKey(key, url), JSON.stringify(data));
    } catch {}
  };

  const fetchText = async (url) => {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed (${res.status}): ${url}`);
    return res.text();
  };

  const fetchJson = async (url) => {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed (${res.status}): ${url}`);
    return res.json();
  };

  const getData = async (key, url) => {
    const cached = getFromStorage(key, url);
    if (cached && Array.isArray(cached)) return cached;

    const data = await fetchJson(url);

    if (Array.isArray(data)) {
      saveToStorage(key, url, data);
    }

    return data;
  };

  const uniq = (arr) => {
    const seen = new Set();
    return arr.filter((x) => {
      const k = norm(x);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  };

  const slugify = (s) =>
    (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const buildVariantJsUrl = (make, model) => `/products/${slugify(make)}-${slugify(model)}.js`;

  const parseVariantTitle = (title) => {
    const parts = (title || "").split("/").map((x) => x.trim());
    return {
      pccode: parts[0] || "",
      make: parts[1] || "",
      model: parts[2] || "",
      body: parts[3] || "",
      engine: parts.slice(4).join(" / ") || "",
    };
  };

  const parseVariantsResponse = (text) => {
    try {
      const j = JSON.parse(text);
      if (j && Array.isArray(j.variants)) return j.variants;
    } catch {}

    const m = text.match(/"variants"\s*:\s*(\[[\s\S]*?\])/);
    if (m && m[1]) {
      try {
        const arr = JSON.parse(m[1]);
        if (Array.isArray(arr)) return arr;
      } catch {}
    }

    const objMatch = text.match(/\{[\s\S]*\}/);
    if (objMatch) {
      try {
        const j = JSON.parse(objMatch[0]);
        if (j && Array.isArray(j.variants)) return j.variants;
      } catch {}
    }

    return null;
  };

  const loadVariants = async (make, model) => {
    const url = buildVariantJsUrl(make, model);
    const text = await fetchText(url);
    const variants = parseVariantsResponse(text);
    if (!variants || !Array.isArray(variants)) throw new Error("Variants parse failed");
    return variants;
  };

  /* ---------------- scroll helpers ---------------- */

  const scrollPanelBodyTop = () => {
    const body = els.body;
    if (!body) return;
    try {
      body.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      body.scrollTop = 0;
    }
  };

  const scrollRootTop = (offset = 0) => {
    const top = root.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, top - offset), behavior: "smooth" });
  };

  const updateUrlWithMakeModel = (make, model) => {
    try {
      const u = new URL(window.location.href);
      if (make) u.searchParams.set("make", make);
      if (model) u.searchParams.set("model", model);
      if (!make) u.searchParams.delete("make");
      if (!model) u.searchParams.delete("model");
      history.replaceState({}, "", u.toString());
    } catch (e) {
      console.warn("URL update failed:", e);
    }
  };

  /* ---------------- layout mode ---------------- */

  const setLayoutMode = (mode) => {
    root.classList.toggle("is-url", mode === "url");
    if (els.titleUrl) els.titleUrl.style.display = mode === "url" ? "" : "none";
    if (els.titlePage) els.titlePage.style.display = mode === "picker" ? "" : "none";
  };

  /* ---------------- hard hide helpers ---------------- */

  const setPanelHeadHiddenHard = (hidden) => {
    if (!els.head) return;
    els.head.hidden = !!hidden;
    els.head.style.display = hidden ? "none" : "";
  };

  const setPageTitleHidden = (hidden) => {
    if (!els.titlePage) return;
    els.titlePage.hidden = !!hidden;
    els.titlePage.style.display = hidden ? "none" : "";
  };

  /* ---------------- loading/error (dynamic only) ---------------- */

  const showDynamicLoading = (msg = "Loading...") => {
    els.dynamic.innerHTML = `<div class="pcfit__loading">${esc(msg)}</div>`;
  };

  const showDynamicError = (msg = "Something went wrong.") => {
    els.dynamic.innerHTML = `<div class="pcfit__error">${esc(msg)}</div>`;
  };

  /* ---------------- ATC show/hide helpers ---------------- */

  const hideAtc = () => {
    if (els.atcWrap) els.atcWrap.hidden = true;
    if (els.atcError) els.atcError.hidden = true;
  };

  const showAtc = ({ showAnother }) => {
    if (!els.atcWrap) return;
    els.atcWrap.hidden = false;

    if (els.anotherBtn) els.anotherBtn.hidden = !showAnother;
    if (els.atcError) els.atcError.hidden = !!state.selectedVariant?.id;

    syncAtcDataset();
  };

  /* ---------------- URL state ---------------- */

  const qs = new URLSearchParams(window.location.search);
  const urlMake = qs.get("make");
  const urlModel = qs.get("model");
  const hasMakeModelInUrl = !!(urlMake && urlModel);

  /* ---------------- state ---------------- */

  const state = {
    make: urlMake || "",
    model: urlModel || "",
    variants: [],
    selectedVariant: null,
    pcMakeModel: null,
    prioritizedMakes: null,
    prioritizedModels: null,
  };

  /* ---------------- breadcrumb ---------------- */

  const buildBreadcrumbParts = () => {
    const parts = [];
    if (state.make) parts.push(state.make);
    if (state.model) parts.push(state.model);
    if (state.selectedVariant) {
      if (state.selectedVariant.body) parts.push(state.selectedVariant.body);
      if (state.selectedVariant.engine) parts.push(state.selectedVariant.engine);
    }
    return parts;
  };

  const renderBreadcrumbHtml = () => {
    const parts = buildBreadcrumbParts();
    if (!parts.length) return "";
    const items = parts
      .map((p) => `<span class="pcfit__crumb">${esc(p)}</span>`)
      .join(`<span class="pcfit__crumb-sep">›</span>`);
    return `<div class="pcfit__breadcrumbs">${items}</div>`;
  };

  const syncBreadcrumb = () => {
    if (els.bc) els.bc.innerHTML = renderBreadcrumbHtml();
  };

  const syncAtcDataset = () => {
    if (!els.atcBtn || !els.atcWrap) return;

    const variantId = state.selectedVariant?.id ? Number(state.selectedVariant.id) : 0;

    const props = {
      Make: state.make || "",
      Model: state.model || "",
      Body: state.selectedVariant?.body || "",
      Engine: state.selectedVariant?.engine || "",
    };

    const atcButtons = els.atcWrap.querySelectorAll('[data-atc="true"]');
    atcButtons.forEach((b) => {
      b.dataset.variantId = variantId ? String(variantId) : "";
      b.dataset.properties = JSON.stringify(props);

      const outOfStockCodes = (b.dataset.outofstock || "")
        .split(",")
        .map((code) => norm(code))
        .filter(Boolean);

      const isOutOfStock = outOfStockCodes.includes(norm(state.selectedVariant?.pccode));
      b.classList.toggle("is-disabled", isOutOfStock);
    });

    if (els.atcError) els.atcError.hidden = !!variantId;
  };

  /* =========================================================
     URL LAYOUT (make/model in URL)
  ========================================================= */

  const renderUrlVariantsList = () => {
    syncBreadcrumb();

    if (state.variants.length === 1) {
      hideAtc();

      const v = state.variants[0];
      const parsed = parseVariantTitle(v.title);
      state.selectedVariant = {
        id: v.id,
        title: v.title,
        pccode: parsed.pccode,
        body: parsed.body,
        engine: parsed.engine,
      };

      syncBreadcrumb();
      els.dynamic.innerHTML = "";
      showAtc({ showAnother: false });
      scrollPanelBodyTop();
      return;
    }

    if (state.selectedVariant) {
      els.dynamic.innerHTML = "";
      showAtc({ showAnother: true });
      scrollPanelBodyTop();
      return;
    }

    hideAtc();

    if (!state.variants.length) {
      els.dynamic.innerHTML = `<div class="pcfit__empty">No fitment found for this vehicle.</div>`;
      scrollPanelBodyTop();
      return;
    }

    
    const disabledCodes = els.outOfStock
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);

    els.dynamic.innerHTML = `
      <div class="pcfit__variants">
        ${state.variants
          .map((v) => {
            const parsed = parseVariantTitle(v.title);
                        
            const isDisabled = disabledCodes.includes(parsed.pccode?.trim());
            
            return `
              <button
                type="button"
                class="pcfit__variant-btn ${isDisabled ? "is-disabled" : ""}"
                data-id="${esc(String(v.id))}"
                data-title="${esc(v.title)}"
                data-pccode="${esc(parsed.pccode)}"
                data-body="${esc(parsed.body)}"
                data-engine="${esc(parsed.engine)}"
                ${isDisabled ? "disabled" : ""}
              >
                <div style="font-weight:900;">${esc(parsed.body || "Body")}</div>
                <div style="margin-top:6px;color:rgba(255,255,255,0.65);font-weight:700;line-height:1.3;">
                  ${esc(parsed.engine || "Engine")}
                </div>
              </button>
            `;
          })
          .join("")}
      </div>
    `;

    els.dynamic.querySelectorAll(".pcfit__variant-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.selectedVariant = {
          id: btn.dataset.id,
          title: btn.dataset.title,
          pccode: btn.dataset.pccode,
          body: btn.dataset.body,
          engine: btn.dataset.engine,
        };
        syncBreadcrumb();
        renderUrlVariantsList();
        scrollRootTop();
        scrollPanelBodyTop();
      });
    });

    scrollPanelBodyTop();
  };

  const initUrlLayout = async () => {
    setLayoutMode("url");

    setPanelHeadHiddenHard(true);
    setPageTitleHidden(true);

    if (els.titleUrl) {
      els.titleUrl.textContent = `pedal commander® for ${state.make} ${state.model}`;
    }

    hideAtc();
    showDynamicLoading("Loading fitment...");

    try {
      state.variants = await loadVariants(state.make, state.model);
      state.selectedVariant = null;
      renderUrlVariantsList();
      scrollPanelBodyTop();
    } catch (e) {
      console.error(e);
      showDynamicError("Fitment data could not be loaded for this vehicle.");
    }
  };

  /* =========================================================
     PICKER LAYOUT (NO URL params)
  ========================================================= */

  const ensurePickerData = async () => {
    const cachedMakeModel = getFromStorage("pcMakeModel", pcMakeModelUrl);
    const cachedPMakes = getFromStorage("prioritizedMakes", prioritizedMakesUrl);
    const cachedPModels = getFromStorage("prioritizedModels", prioritizedModelsUrl);

    if (
      Array.isArray(cachedMakeModel) &&
      Array.isArray(cachedPMakes) &&
      Array.isArray(cachedPModels)
    ) {
      state.pcMakeModel = cachedMakeModel;
      state.prioritizedMakes = cachedPMakes;
      state.prioritizedModels = cachedPModels;
      return;
    }

    const [mm, pmk, pmd] = await Promise.all([
      getData("pcMakeModel", pcMakeModelUrl),
      getData("prioritizedMakes", prioritizedMakesUrl),
      getData("prioritizedModels", prioritizedModelsUrl),
    ]);

    state.pcMakeModel = mm;
    state.prioritizedMakes = pmk;
    state.prioritizedModels = pmd;
  };

  const renderMakes = () => {
    setLayoutMode("picker");
    hideAtc();

    state.make = "";
    state.model = "";
    state.variants = [];
    state.selectedVariant = null;

    setPanelHeadHiddenHard(false);
    setPageTitleHidden(false);
    syncBreadcrumb();

    if (els.headTitle) els.headTitle.textContent = "Select Make";
    if (els.back) {
      els.back.style.visibility = "hidden";
      els.back.onclick = null;
    }

    const allMakes = (state.pcMakeModel || []).map((x) => x.make).filter(Boolean);
    const prioritizedSet = new Set((state.prioritizedMakes || []).map(norm));

    const best = uniq(allMakes.filter((m) => prioritizedSet.has(norm(m))));
    const other = uniq(allMakes.filter((m) => !prioritizedSet.has(norm(m)))).sort((a, b) => a.localeCompare(b));

    const renderGroup = (groupTitle, list) => {
      if (!list.length) return "";
      return `
        <div class="pcfit__group-title" style="margin-top:8px;">${esc(groupTitle)}</div>
        <div class="pcfit__list">
          ${list
            .map((m) => `<button type="button" class="pcfit__item" data-make="${esc(m)}">${esc(m)}</button>`)
            .join("")}
        </div>
      `;
    };

    els.dynamic.innerHTML = renderGroup("Best sellers", best) + renderGroup("Other makes", other);

    els.dynamic.querySelectorAll("[data-make]").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.make = btn.dataset.make || "";
        state.model = "";
        syncBreadcrumb();
        renderModels(state.make);
        scrollPanelBodyTop();
      });
    });

    scrollPanelBodyTop();
    updateUrlWithMakeModel("", "");
  };

  const renderModels = (make) => {
    setLayoutMode("picker");
    hideAtc();

    state.model = "";
    state.variants = [];
    state.selectedVariant = null;

    setPanelHeadHiddenHard(false);
    setPageTitleHidden(false);
    syncBreadcrumb();

    if (els.headTitle) els.headTitle.textContent = "Select Model";
    if (els.back) {
      els.back.style.visibility = "visible";
      els.back.onclick = () => {
        renderMakes();
        scrollPanelBodyTop();
      };
    }

    const makeObj = (state.pcMakeModel || []).find((x) => norm(x.make) === norm(make));
    const modelsFull = (makeObj?.models || []).filter(Boolean);

    const stripMakePrefix = (mk, mf) => {
      const full = (mf || "").trim();
      const mkk = (mk || "").trim();
      if (!full || !mkk) return full;
      const lf = full.toLowerCase();
      const lm = mkk.toLowerCase();
      if (lf.startsWith(lm + " ")) return full.slice(mkk.length).trim();
      return full;
    };

    const models = modelsFull.map((full) => {
      const short = stripMakePrefix(make, full);
      return { full, label: short || full };
    });

    const best = [];
    const other = [];

    models.forEach((m) => {
      const isBest = (state.prioritizedModels || []).some((p) => {
        const pn = norm(p);
        return pn === norm(m.full) || pn === norm(`${make} ${m.label}`) || pn.includes(norm(m.label));
      });
      (isBest ? best : other).push(m);
    });

    const bestUniq = uniq(best.map((x) => x.label));
    const otherUniq = uniq(other.map((x) => x.label)).sort((a, b) => a.localeCompare(b));

    const renderGroup = (groupTitle, list) => {
      if (!list.length) return "";
      return `
        <div class="pcfit__group-title" style="margin-top:8px;">${esc(groupTitle)}</div>
        <div class="pcfit__list">
          ${list
            .map((m) => `<button type="button" class="pcfit__item" data-model="${esc(m)}">${esc(m)}</button>`)
            .join("")}
        </div>
      `;
    };

    els.dynamic.innerHTML = renderGroup("Best sellers", bestUniq) + renderGroup("Other models", otherUniq);

    els.dynamic.querySelectorAll("[data-model]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        state.model = btn.dataset.model || "";

        updateUrlWithMakeModel(state.make, state.model);
        syncBreadcrumb();

        hideAtc();
        showDynamicLoading("Loading fitment...");
        scrollPanelBodyTop();

        try {
          state.variants = await loadVariants(state.make, state.model);
          state.selectedVariant = null;
          renderVariantsStep();
          scrollPanelBodyTop();
        } catch (e) {
          console.error(e);
          showDynamicError("Fitment data could not be loaded.");
          scrollPanelBodyTop();
        }
      });
    });

    scrollPanelBodyTop();
  };

  const renderVariantsStep = () => {
    setLayoutMode("picker");
    syncBreadcrumb();

    const single = state.variants.length === 1;

    if (els.headTitle) els.headTitle.textContent = "Select Body / Engine";
    if (els.back) {
      els.back.style.visibility = "visible";
      els.back.onclick = () => {
        renderModels(state.make);
        scrollPanelBodyTop();
      };
    }

    if (single) {
      hideAtc();

      const v = state.variants[0];
      const parsed = parseVariantTitle(v.title);
      state.selectedVariant = {
        id: v.id,
        title: v.title,
        pccode: parsed.pccode,
        body: parsed.body,
        engine: parsed.engine,
      };

      syncBreadcrumb();

      setPanelHeadHiddenHard(true);
      setPageTitleHidden(true);

      els.dynamic.innerHTML = "";
      showAtc({ showAnother: false });

      scrollPanelBodyTop();
      return;
    }

    if (state.selectedVariant) {
      setPanelHeadHiddenHard(true);
      setPageTitleHidden(true);

      els.dynamic.innerHTML = "";
      showAtc({ showAnother: true });

      scrollPanelBodyTop();
      return;
    }

    hideAtc();
    setPanelHeadHiddenHard(false);
    setPageTitleHidden(false);

    if (!state.variants.length) {
      els.dynamic.innerHTML = `<div class="pcfit__empty">No fitment found for this vehicle.</div>`;
      scrollPanelBodyTop();
      return;
    }


    const disabledCodes = els.outOfStock
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);

    els.dynamic.innerHTML = `
      <div class="pcfit__variants">
        ${state.variants
          .map((v) => {
            const parsed = parseVariantTitle(v.title);
                        
            const isDisabled = disabledCodes.includes(parsed.pccode?.trim());

            return `
              <button
                type="button"
                class="pcfit__variant-btn ${isDisabled ? "is-disabled" : ""}"
                data-id="${esc(String(v.id))}"
                data-title="${esc(v.title)}"
                data-pccode="${esc(parsed.pccode)}"
                data-body="${esc(parsed.body)}"
                data-engine="${esc(parsed.engine)}"
                ${isDisabled ? "disabled" : ""}
              >
                <div style="font-weight:900;">${esc(parsed.body || "Body")}</div>
                <div style="margin-top:6px;color:rgba(255,255,255,0.65);font-weight:700;line-height:1.3;">
                  ${esc(parsed.engine || "Engine")}
                </div>
              </button>
            `;
          })
          .join("")}
      </div>
    `;

    els.dynamic.querySelectorAll(".pcfit__variant-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        setPanelHeadHiddenHard(true);

        state.selectedVariant = {
          id: btn.dataset.id,
          title: btn.dataset.title,
          pccode: btn.dataset.pccode,
          body: btn.dataset.body,
          engine: btn.dataset.engine,
        };

        syncBreadcrumb();
        renderVariantsStep();

        scrollRootTop(90);
        scrollPanelBodyTop();
      });
    });

    scrollPanelBodyTop();
  };

  if (els.anotherBtn && els.anotherBtn.dataset.bound !== "1") {
    els.anotherBtn.dataset.bound = "1";
    els.anotherBtn.addEventListener("click", () => {
      state.selectedVariant = null;
      hideAtc();

      const isUrl = root.classList.contains("is-url");

      if (isUrl) {
        setPanelHeadHiddenHard(true);
        setPageTitleHidden(true);

        renderUrlVariantsList();
        scrollRootTop();
      } else {
        setPanelHeadHiddenHard(false);
        setPageTitleHidden(false);

        renderVariantsStep();
      }

      scrollPanelBodyTop();
    });
  }

  /* ---------------- init ---------------- */

  try {
    hideAtc();
    showDynamicLoading("Loading...");

    if (hasMakeModelInUrl) {
      await initUrlLayout();
    } else {
      setLayoutMode("picker");
      setPanelHeadHiddenHard(false);
      setPageTitleHidden(false);
      showDynamicLoading("Loading vehicle list...");
      await ensurePickerData();
      renderMakes();
    }
  } catch (e) {
    console.error(e);
    showDynamicError("Initialization failed.");
  }
})();